// UPDATE SCREENING JOB ******************************************************
// pathname: /api/jobs/{id}
// method: PATCH
// ************************************************************************************************
import { useState } from 'react';
import { ApiSchemaScreening } from '@type/api/apiUtilityFnScreening';
import { screeningBaseURL } from '@utils/data-fetching/utils';

interface UpdateJobInput {
  jobId: string;
  data: ApiSchemaScreening<'Job.JobUpdateInput.jsonMergePatch'>;
}

/**
 * @description Hook to update a screening job (screeningContext and screeningQuestions).
 */
export const useSwrUpdateJob = () => {
  const [isMutating, setIsMutating] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const trigger = async (input: UpdateJobInput): Promise<ApiSchemaScreening<'Job.JobOutput'> | null> => {
    setIsMutating(true);
    setError(null);

    try {
      const response = await fetch(`${screeningBaseURL}/api/jobs/${input.jobId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/merge-patch+json',
        },
        credentials: 'include',
        body: JSON.stringify(input.data),
      });

      if (!response.ok) {
        throw new Error('Failed to update job');
      }

      return await response.json() as ApiSchemaScreening<'Job.JobOutput'>;
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Unknown error'));
      return null;
    } finally {
      setIsMutating(false);
    }
  };

  return {
    trigger,
    isMutating,
    error,
  };
};
